import { ToggleComponent } from '../../../featureToggle';
import ButtonAdd from './ButtonAdd';
import ButtonAddNuttall from '../../../customized/alan-nuttall-flexeserve-eu/components/commons/buttonAdd/ButtonAdd';

export default ToggleComponent(ButtonAdd, {
  StyledComponentsVariants: {
    'alan-nuttall-flexeserve-eu': ButtonAddNuttall,
  },
});
